import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-group-name',
  templateUrl: './group-name.component.html',
  styleUrls: ['./group-name.component.css']
})
export class GroupNameComponent implements OnInit {

  group: FormGroup;
  constructor(private fb: FormBuilder, private dialogRef: MatDialogRef<GroupNameComponent>) { }

  ngOnInit(): void {
    this.group = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+[a-zA-Z0-9 ]+$/)]]
    });
  }
  onSave() {
    this.dialogRef.close({ result: true, name: this.group.controls.name.value });
  }
  onCancel() {
    this.dialogRef.close({ result: false });
  }
}
